
import React, { useState } from 'react';
import { Formik, Form, getIn, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import InputField from 'components/Input-Field/input-field';
import SelectField from 'components/Select-Field/select-field.js';
import {
  Box,
  Button,
  Grid,
  Typography,
  IconButton,
  InputAdornment,
  Stack,
  useTheme,
  ButtonGroup,
  CircularProgress,
} from '@mui/material';
import { AggregateOrderExpenses, calculateOrderTotal } from 'utils/calculations';
import { formatCurrency } from 'utils/formatter';
import CTTabs from 'components/CTTabs.js';
import DataDialog from 'components/dialogs/DataDialog';
import 'rsuite/dist/rsuite.min.css';
import { DatePicker, Toggle } from 'rsuite';
import '../../../styles/rsuite-component.css';
import CustomSelectField from 'components/Select-Field/custom-select';
import { AddCircleOutlineOutlined, HighlightOffOutlined } from '@mui/icons-material';
import * as BrokerAction from 'actions/broker-action';
import * as LocationAction from 'actions/location-action';
import * as TruckAction from 'actions/truck-action';
import TruckForm from 'containers/Equipment/truck-form';
import LocationForm from 'containers/Location/location-form';
import BrokerForm from 'containers/Broker/broker-form';
import Radar from 'radar-sdk-js';
import { LOAD_TYPE_MAPPING } from 'utils/constant';
// import ConfirmationDialog from 'components/dialogs/ConfirmationDialog';
import { useConfirmationDialog } from 'components/dialogs/ConfirmationDialogWithHook';
import FormElements from 'components/FormElements';
import { tokens } from 'theme/tokens';
import FTIcons from 'assets/icons/FTIcons';
import OrderExpense from 'containers/expenses/order-expense';
import FileUploader from 'components/FileUploader';
import { extractPreNoteDocument } from 'services/document-service';
import { set } from 'lodash';
import { color } from 'framer-motion';

const OTRLoadForm = (props) => {
  const {
    isEdit,
    orderForm,
    formAction,
    locations, //companies
    brokers,
    trucks,
    saveFormHandler,
    updateFormHandler,
    cancelDialogHandler,
    saveBroker,
    saveLocation,
    saveTruck,
  } = props;

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [order, setOrder] = useState(orderForm);
  let { id, summary, origin, destination, equipment } = order;
  const [expense, setExpense] = useState(order.expense);
  const [expenseAction, setExpenseAction] = useState('Save');
  const [expenseList, setExpenseList] = useState(summary.expenses);
  const [isExpenseDialogOpen, setExpenseDialog] = useState(false);
  const [isPreNoteDocument, setIsPreNoteDocument] = useState(null);
  const [isPreNoteDocumentDialogOpen, setPreNoteDocumentDialog] = useState(false);
  const [isProcessingPreNoteDocument, setIsProcessingPreNoteDocument] = useState(false);
  const [preNoteToast, setPreNoteToast] = useState({});

  const [currentOriginTabIndex, setCurrentOriginTabIndex] = useState(0);
  const [currentDestinationTabIndex, setCurrentDestinationTabIndex] = useState(0);

  const [originTab, setOriginTab] = useState(origin.map((o, idx) => `Origin ${idx + 1}`));
  const [destinationTab, setDestinationTab] = useState(destination.map((o, idx) => `Destination ${idx + 1}`));

  const [isBrokerFormDialogOpen, setBrokerFormDialog] = useState(false);
  const [isLocationFormDialogOpen, setLocationFormDialog] = useState(false);
  const [isTruckFormDialogOpen, setTruckFormDialog] = useState(false);

  const [confirm, ConfirmationDialog] = useConfirmationDialog();
  const [isProcessingDistanceCalculation, setProcessingDistanceCalculation] = useState(false);
  const [originGeoList, setOriginGeoList] = useState({});
  const [destinationGeoList, setDestinationGeoList] = useState({});

  const getDisplayLabel = (item, type) => {
    let primaryText = '', secondaryText = '', geo;
    let id = '';
    if (item) {
      id = item.id;
      if (type === 'DRIVER') {
        /* For driver dropdown in driver pay manager page */
        primaryText = item.fullName;
        secondaryText = item.phone;
      } else if (type === 'BROKER' || type === 'LOCATION') {
        primaryText = item.name;
        secondaryText = item.address && `${item.address.street},${item.address.city},${item.address.state},${item.address.country}`;
        geo = item.address && item.address.geo;
      } else if (type === 'TRUCK' || type === 'TRAILER') {
        primaryText = item.truckNumber;
        const truckType = item.truckType === 'LIVESTOCK' ? 'TRACTOR' : item.truckType;
        secondaryText = `Type: ${truckType} License: ${item.licensePlate}`;
      }
    }
    const reactSelectObj = {
      id: id,
      label: <Box key={`${type}:${primaryText}`}>
        <Typography variant='body1' fontWeight={600}>{primaryText}</Typography>
        <Typography variant='caption'>{secondaryText}</Typography>
      </Box>,
      value: primaryText,
      geo: geo,
      data: item
    };
    return reactSelectObj;
  };

  const addNewTab = (tabType, values) => {
    const currentOrder = order;
    if (tabType === 'ORIGIN') {
      const { origin } = values; // This is done because of enableReinitialize flag.
      const newOrigin = {
        id: '',
        name: '',
        appointment: new Date(),
        requiresAppointment: false, // We don't need another boolean. If user enters the data in this field it means we need open appointment. 
        contactPerson: null,
        contactPhone: null,
        contactEmail: null,
        notes: null,
        street: null,
        city: null,
        state: null,
        zipcode: null,
        address: null,
        country: null
      };

      const tabCount = originTab.length + 1;
      const updatedTabs = originTab.concat([`Origin ${tabCount}`]);

      //update the Origin to have new tab and origin and rest will be same.
      origin.push(newOrigin);
      // currentOrder.origin = origin;

      // setOrder(currentOrder);
      setOriginTab(updatedTabs);
      setCurrentOriginTabIndex(previous => previous + 1)
    } else {
      const { destination } = values; // This is done because of enableReinitialize flag.
      const newDestination = {
        id: '',
        name: '',
        appointment: new Date(),
        requiresAppointment: false, // We don't need another boolean. If user enters the data in this field it means we need open appointment. 
        contactPerson: null,
        contactPhone: null,
        contactEmail: null,
        notes: null,
        street: null,
        city: null,
        state: null,
        zipcode: null,
        address: null,
        country: null
      };

      const tabCount = destinationTab ? destinationTab.length + 1 : 1;
      const updatedTabs = destinationTab.concat([`Destination ${tabCount}`]);

      //update the Destination to have new tab and origin and rest will be same.
      destination.push(newDestination);
      // currentOrder.destination = destination;
      // setOrder(currentOrder);
      setDestinationTab(updatedTabs);
      setCurrentDestinationTabIndex(previous => previous + 1);
    }
  };

  const handleRemoveTab = async (tabType, tab, value) => {
    const confirmed = await confirm({
      title: 'Remove Stop',
      icon: <HighlightOffOutlined color='error' fontSize='medium' style={{ marginRight: '10' }} />,
      content: <Typography variant='subtitle2'>Are you sure, you want to remove this stop?</Typography>
    });
    if (confirmed) {
      removeTab(tabType, tab, value);
    }
  };

  const removeTab = (tabType, tab, values) => {
    const currentOrder = order;
    if (tabType === 'ORIGIN') {
      const { origin } = values; // This is done because of enableReinitialize flag.      
      const indexToRemove = Number(tab.split(' ')[1]) - 1;

      const updatedOrigins = origin.filter((_, idx) => idx !== indexToRemove);
      const filteredTabs = originTab.filter((o_tab) => { return o_tab !== tab; });

      let activeTabIndex = currentOriginTabIndex;
      if (indexToRemove === currentOriginTabIndex) {
        activeTabIndex = Math.max(currentOriginTabIndex - 1, 0);
      } else if (indexToRemove < currentOriginTabIndex) {
        activeTabIndex = currentOriginTabIndex - 1;
      }
      setCurrentOriginTabIndex(activeTabIndex);
      setOriginTab(filteredTabs);
      currentOrder.origin = updatedOrigins;
      setOrder(currentOrder);
    } else if (tabType === 'DESTINATION') {
      const { destination } = values; // This is done because of enableReinitialize flag.      
      const indexToRemove = Number(tab.split(' ')[1]) - 1;

      const updatedDestinations = destination.filter((_, idx) => idx !== indexToRemove);
      const filteredTabs = destinationTab.filter((o_tab) => { return o_tab !== tab; });

      let activeTabIndex = currentDestinationTabIndex;
      if (indexToRemove === currentDestinationTabIndex) {
        activeTabIndex = Math.max(currentDestinationTabIndex - 1, 0);
      } else if (indexToRemove < currentDestinationTabIndex) {
        activeTabIndex = currentDestinationTabIndex - 1;
      }
      setCurrentDestinationTabIndex(activeTabIndex);
      setDestinationTab(filteredTabs);
      currentOrder.destination = updatedDestinations;
      setOrder(currentOrder);
    }
  };

  const changeTab = (tabType, tabIndex) => {
    if (tabType === 'ORIGIN') {
      setCurrentOriginTabIndex(tabIndex);
    } else if (tabType === 'DESTINATION') {
      setCurrentDestinationTabIndex(tabIndex);
    }
  };

  /* Expenses */
  const editRow = (row) => {
    setExpense(row);
    setExpenseAction('Update');
  };

  const saveExpense = (expense) => {
    expense.id = expenseList.length + 1;
    setExpenseList([...expenseList, expense]);
    setExpense(Object.create(expense, order.expense));
  };

  const updateExpense = (expense) => {
    const index = expenseList.findIndex(e => e.id === expense.id);
    if (index !== -1) {
      const data = expenseList.map(item => item.id === expense.id ? { ...expense } : { ...item });
      setExpenseList(data);
      setExpense(Object.create(expense, order.expense));
    }
  };

  const deleteExpense = (expense) => {
    const index = expenseList.findIndex(e => e.id === expense.id);
    if (index !== -1) {
      const data = [...expenseList.filter((item) => item.id !== expense.id)];
      setExpenseList(data);
    }
  };

  const OrderSchema = Yup.object().shape({
    summary: Yup.object().shape({
      loadType: Yup.string().required('Load Type is required'),
      broker: Yup.string().required('Broker is required'),
      brokerOrderNumber: Yup.string().required('Broker Order Number is required'),
      lineHaulCharges: Yup.number()
        .required('LineHaul required')
        .min(0, 'LineHaul cannot be negative'),
    }),
    origin: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().required('Origin is required'),
        appointment: Yup.string().required('Origin appointment is required'),
      })
    ),
    destination: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().required('Destination is required'),
        appointment: Yup.string().required('Destination appointment is required')
      }),
    ),
  });

  /* If Edit Order */
  if (isEdit || isPreNoteDocument) {
    summary.broker = getDisplayLabel(summary.broker, 'BROKER');
    origin = origin.map(item => ({ ...item, name: getDisplayLabel(item, 'LOCATION') }));
    destination = destination.map(item => ({ ...item, name: getDisplayLabel(item, 'LOCATION') }));
    equipment.truck = getDisplayLabel(equipment.truck, 'TRUCK');
  }

  const closeFormDialog = (dialog) => {
    if (dialog === 'broker') {
      setBrokerFormDialog(false);
    } else if (dialog === 'location') {
      setLocationFormDialog(false);
    } else {
      setTruckFormDialog(false);
    }
    props.resetToastState(dialog);
  };

  const handleLocationChange = (setFieldValue, locationType, location, tabIndex) => {
    const radarLocation = location.geo && location.geo.lat && location.geo.lng ? new Object({
      latitude: location.geo.lat,
      longitude: location.geo.lng
    }) : null;

    if (radarLocation) {
      let originGeoByIndex = { ...originGeoList };
      let destinationGeoByIndex = { ...destinationGeoList };
      if (locationType === 'ORIGIN') {
        originGeoByIndex = { [tabIndex]: radarLocation };
        setOriginGeoList(originGeoByIndex);
      } else {
        destinationGeoByIndex = { [tabIndex]: radarLocation };
        setDestinationGeoList(destinationGeoByIndex);
      }
      //Make API call only when both origin and destinations are selected.
      if (Object.keys(originGeoByIndex).length > 0 && Object.keys(destinationGeoByIndex).length > 0) {
        setProcessingDistanceCalculation(true);
        Radar.matrix({
          origins: Object.values(originGeoByIndex),
          destinations: Object.values(destinationGeoByIndex),
          modes: 'truck',
          units: 'imperial'
        }).then(result => {
          result.matrix.forEach(matrixResult => {
            matrixResult.forEach(mr => {
              const { distance, duration } = mr;
              if (distance && distance.text) {
                const arr = distance.text.split(' ');
                if (arr && arr.length === 2) {
                  setFieldValue('summary.distance', Number(arr[0]));
                  setFieldValue('summary.distanceUnit', arr[1]);
                }
                setFieldValue('summary.duration', duration.text);
              }
            });
          });
          setProcessingDistanceCalculation(false);
        });
      }
    }
  };

  const handleCreateLoadWithAI = (PreNote) => {
    setIsProcessingPreNoteDocument(true);
    setPreNoteToast({ type: 'INFO', message: 'Loading Document...' });
    setTimeout(() => {
      setPreNoteToast({ type: 'INFO', message: 'Extracting Load Information...' });
      extractPreNoteDocument(PreNote).then((res) => {
        if (res.status === 200 && res.statusText === 'OK') {
          const data = res.data;
          const PreNoteLoad = { summary: data.summary, origin: data.originLocations, destination: data.destinationLocations, equipment: data.equipment };
          setOrder(PreNoteLoad);
          setIsPreNoteDocument(true);
          setPreNoteToast({ type: 'SUCCESS', message: 'Load information extracted. Please verify and save the load.' });
        }
      })
        .catch((err) => {
          setPreNoteToast({ type: 'ERROR', message: 'Failed to extract load information from document. Please try again.' });
        })
        .finally(() => {
          setIsProcessingPreNoteDocument(false);
        });
    }, 1000);
  };

  const { isProcessing, toast } = props; //Toast
  return (
    <Box>
      <Formik
        initialValues={{ summary, origin, destination, equipment }}
        enableReinitialize={true}
        validationSchema={OrderSchema}
        validateOnMount={true}
        onSubmit={(values) => {
          const dispatchOrder = Object.create(null);
          //Check if expenses are added/updated/deleted when creating or updating order.
          values.summary.expenses = expenseList;
          dispatchOrder.summary = values.summary;
          dispatchOrder.summary.orderCreateDate = new Date();
          dispatchOrder.origin = values.origin;
          dispatchOrder.destination = values.destination;
          dispatchOrder.equipment = values.equipment;
          if (formAction === 'Save') {
            saveFormHandler(dispatchOrder);
          } else {
            dispatchOrder.id = id;
            updateFormHandler(dispatchOrder);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          touched,
          values,
          setFieldValue,
        }) => (
          <Form>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={1}
              alignItems={'stretch'}
            >
              <FormElements.FormSection sx={{ flex: 1, width: '100%', flexShrink: 0 }}>
                {/* Load Summary */}
                <FormElements.FormSubsection>
                  <Grid container spacing={1}>
                    <Grid size={{ xs: 12 }}>
                      <Box
                        display={'flex'}
                        justifyContent={'space-between'}
                      >
                        <Box display={'flex'} gap={2} alignItems={'center'}>
                        </Box>
                        <Button
                          size='small'
                          color='secondary'
                          variant='outlined'
                          startIcon={<FTIcons.AIIcon width={20} height={20} fill={colors.secondary.main}/>}
                          onClick={() => setPreNoteDocumentDialog(true)}
                        >Create Load With AI
                        </Button>
                      </Box>
                    </Grid>
                    <Grid size={{ xs: 6, sm: 4 }}>
                      <SelectField
                        fullWidth={true}
                        name='summary.loadType'
                        label={'Select Load Type'}
                        variant='outlined'
                        value={values.summary.loadType}
                        error={Boolean(
                          getIn(touched, 'summary.loadType') &&
                          getIn(errors, 'summary.loadType')
                        )}
                        helperText={Boolean(
                          getIn(touched, 'summary.loadType') &&
                          getIn(errors, 'summary.loadType')
                        )}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        options={Object.keys(LOAD_TYPE_MAPPING)}
                        size='small'
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 8 }}>
                      <Box display='flex'>
                        <Box flex={1}>
                          <CustomSelectField
                            type='BROKER'
                            id='brokers'
                            label='Broker Name'
                            name='summary.broker'
                            data={brokers && brokers.map(b => getDisplayLabel(b, 'BROKER'))}
                            value={values.summary.broker}
                            onChange={selected => setFieldValue('summary.broker', selected)}
                          />
                          <ErrorMessage name={`summary.broker`} component={'grid'} style={{ color: colors.error.main }} />
                        </Box>
                        <IconButton color='primary' onClick={() => setBrokerFormDialog(true)} size='small'><AddCircleOutlineOutlined /></IconButton>
                      </Box>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <InputField
                        type='text'
                        label='Broker Order#'
                        name='summary.brokerOrderNumber'
                        value={values.summary.brokerOrderNumber}
                        variant='outlined'
                        fullWidth
                        error={Boolean(
                          getIn(touched, 'summary.brokerOrderNumber') &&
                          getIn(errors, 'summary.brokerOrderNumber')
                        )}
                        helperText={Boolean(
                          getIn(touched, 'summary.brokerOrderNumber') &&
                          getIn(errors, 'summary.brokerOrderNumber')
                        )}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                      />
                    </Grid>
                    <Grid size={{ xs: 4, sm: 3 }}>
                      <InputField
                        type='number'
                        label='Order Rate'
                        name='summary.lineHaulCharges'
                        value={values.summary.lineHaulCharges}
                        variant='outlined'
                        fullWidth
                        error={Boolean(
                          getIn(touched, 'summary.lineHaulCharges') &&
                          getIn(errors, 'summary.lineHaulCharges')
                        )}
                        helperText={Boolean(
                          getIn(touched, 'summary.lineHaulCharges') &&
                          getIn(errors, 'summary.lineHaulCharges')
                        )}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                      />
                    </Grid>
                    <Grid size={{ xs: 4, sm: 3 }}>
                      <InputField
                        type='number'
                        label='FSC'
                        name='summary.fuelCharges'
                        value={values.summary.fuelCharges}
                        variant='outlined'
                        fullWidth
                        error={Boolean(
                          getIn(touched, 'summary.fuelCharges') &&
                          getIn(errors, 'summary.fuelCharges')
                        )}
                        helperText={Boolean(
                          getIn(touched, 'summary.fuelCharges') &&
                          getIn(errors, 'summary.fuelCharges')
                        )}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                      />
                      <Toggle
                        name='summary.fuelChargesType'
                        value={values.summary.fuelChargesType}
                        checkedChildren={'$'}
                        unCheckedChildren={'%'}
                        defaultChecked={values.summary.fuelChargesType === '$'}
                        onChange={checked => {
                          const val = checked ? '$' : '%';
                          setFieldValue('summary.fuelChargesType', val);
                        }
                        }
                        style={{ position: 'absolute', margin: '8px -50px', color: 'red' }}
                      />
                    </Grid>
                    <Grid size={{ xs: 4, sm: 2 }}>
                      <Box display={'flex'} alignItems={'center'} mt={1}>
                        <IconButton color={'primary'} onClick={() => setExpenseDialog(true)} size='small'>
                          <AddCircleOutlineOutlined />
                        </IconButton>
                        <Typography variant='body1'>Expense</Typography>
                      </Box>
                    </Grid>
                    <Grid size={{ xs: 6, sm: 6 }}>
                      <Box display='flex'>
                        <Box flex={1}>
                          <CustomSelectField
                            type='TRUCK'
                            id='trucks'
                            label='Select Truck'
                            name='equipment.truck'
                            data={trucks.map(b => getDisplayLabel(b, 'TRUCK'))}
                            value={values.equipment.truck}
                            onChange={selected => setFieldValue('equipment.truck', selected)}
                          />
                          <ErrorMessage name={'equipment.truck'} component={'grid'} style={{ color: colors.error.main }} />
                        </Box>
                        <IconButton color='primary' onClick={() => setTruckFormDialog(true)} size='small'><AddCircleOutlineOutlined /></IconButton>
                      </Box>
                    </Grid>
                    <Grid size={{ xs: 6, sm: 3 }}>
                      <InputField
                        type='text'
                        label='Trailer Number'
                        name='equipment.trailerNumber'
                        value={values.equipment.trailerNumber}
                        variant='outlined'
                        fullWidth
                        error={Boolean(
                          getIn(touched, 'equipment.trailerNumber') &&
                          getIn(errors, 'equipment.trailerNumber')
                        )}
                        helperText={Boolean(
                          getIn(touched, 'equipment.trailerNumber') &&
                          getIn(errors, 'equipment.trailerNumber')
                        )}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                      />
                    </Grid>
                    <Grid size={{ xs: 6, sm: 3 }}>
                      <InputField
                        type='text'
                        label='Trailer License'
                        name='equipment.trailerLicense'
                        value={values.equipment.trailerLicense}
                        variant='outlined'
                        fullWidth
                        error={Boolean(
                          getIn(touched, 'equipment.trailerLicense') &&
                          getIn(errors, 'equipment.trailerLicense')
                        )}
                        helperText={Boolean(
                          getIn(touched, 'equipment.trailerLicense') &&
                          getIn(errors, 'equipment.trailerLicense')
                        )}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                      />
                    </Grid>
                    <Grid size={{ xs: 6, sm: 3 }}>
                      <InputField
                        type='text'
                        label='Pallet Qty'
                        name='summary.palletQty'
                        value={values.summary.palletQty}
                        variant='outlined'
                        fullWidth
                        error={Boolean(
                          getIn(touched, 'summary.palletQty') &&
                          getIn(errors, 'summary.palletQty')
                        )}
                        helperText={Boolean(
                          getIn(touched, 'summary.palletQty') &&
                          getIn(errors, 'summary.palletQty')
                        )}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                      />
                    </Grid>
                    <Grid size={{ xs: 6, sm: 3 }}>
                      <InputField
                        type='text'
                        label='Temperature'
                        name='summary.temperature'
                        value={values.summary.temperature}
                        variant='outlined'
                        fullWidth
                        error={Boolean(
                          getIn(touched, 'summary.temperature') &&
                          getIn(errors, 'summary.temperature')
                        )}
                        helperText={Boolean(
                          getIn(touched, 'summary.temperature') &&
                          getIn(errors, 'summary.temperature')
                        )}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                        slotProps={{
                          input: {
                            endAdornment: <InputAdornment style={{ margin: '-15px' }}>
                              <SelectField
                                name='summary.tempUnit'
                                variant='outlined'
                                value={values.summary.tempUnit}
                                error={Boolean(
                                  getIn(touched, 'summary.tempUnit') &&
                                  getIn(errors, 'summary.tempUnit')
                                )}
                                helperText={Boolean(
                                  getIn(touched, 'summary.tempUnit') &&
                                  getIn(errors, 'summary.tempUnit')
                                )}
                                onBlur={handleBlur}
                                onChange={handleChange}
                                options={['C', 'F']}
                                size='small'
                              />
                            </InputAdornment>
                          }
                        }}
                      />
                    </Grid>
                    <Grid size={{ xs: 6, sm: 3 }}>
                      <InputField
                        type='text'
                        label='Weight'
                        name='summary.weight'
                        value={values.summary.weight}
                        variant='outlined'
                        fullWidth
                        error={Boolean(
                          getIn(touched, 'summary.weight') &&
                          getIn(errors, 'summary.weight')
                        )}
                        helperText={Boolean(
                          getIn(touched, 'summary.weight') &&
                          getIn(errors, 'summary.weight')
                        )}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                        slotProps={{
                          input: {
                            endAdornment: <InputAdornment style={{ margin: '-15px' }}>
                              <SelectField
                                name='summary.weightUnit'
                                variant='outlined'
                                value={values.summary.weightUnit}
                                error={Boolean(
                                  getIn(touched, 'summary.weightUnit') &&
                                  getIn(errors, 'summary.weightUnit')
                                )}
                                helperText={Boolean(
                                  getIn(touched, 'summary.weightUnit') &&
                                  getIn(errors, 'summary.weightUnit')
                                )}
                                onBlur={handleBlur}
                                onChange={handleChange}
                                options={['lbs', 'kgs']}
                                size='small'
                              />
                            </InputAdornment>
                          }
                        }}
                      />
                    </Grid>
                    <Grid size={{ xs: 6, sm: 3 }}>
                      <InputField
                        type='text'
                        label='Length'
                        name='summary.length'
                        value={values.summary.length}
                        variant='outlined'
                        fullWidth
                        error={Boolean(
                          getIn(touched, 'summary.length') &&
                          getIn(errors, 'summary.length')
                        )}
                        helperText={Boolean(
                          getIn(touched, 'summary.length') &&
                          getIn(errors, 'summary.length')
                        )}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                        slotProps={{
                          input: {
                            endAdornment: <InputAdornment style={{ margin: '-15px' }}>
                              <SelectField
                                name='summary.lengthUnit'
                                variant='outlined'
                                value={values.summary.lengthUnit}
                                error={Boolean(
                                  getIn(touched, 'summary.lengthUnit') &&
                                  getIn(errors, 'summary.lengthUnit')
                                )}
                                helperText={Boolean(
                                  getIn(touched, 'summary.lengthUnit') &&
                                  getIn(errors, 'summary.lengthUnit')
                                )}
                                onBlur={handleBlur}
                                onChange={handleChange}
                                options={['feet', 'inches']}
                                size='small'
                              />
                            </InputAdornment>
                          }
                        }}
                      />
                    </Grid>
                    {values.summary.loadType === 'DROP AND HOOK' && <Grid size={{ xs: 6, sm: 3 }}>
                      <InputField
                        type='text'
                        label='Trailer Number Hook'
                        name='equipment.trailerNumberHook'
                        value={values.equipment.trailerNumberHook}
                        variant='outlined'
                        fullWidth
                        error={Boolean(
                          getIn(touched, 'equipment.trailerNumberHook') &&
                          getIn(errors, 'equipment.trailerNumberHook')
                        )}
                        helperText={Boolean(
                          getIn(touched, 'equipment.trailerNumberHook') &&
                          getIn(errors, 'equipment.trailerNumberHook')
                        )}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                      />
                    </Grid>}
                    {values.summary.loadType === 'DROP AND HOOK' && <Grid size={{ xs: 6, sm: 3 }}>
                      <InputField
                        type='text'
                        label='Trailer License Hook'
                        name='equipment.trailerLicenseHook'
                        value={values.equipment.trailerLicenseHook}
                        variant='outlined'
                        fullWidth
                        error={Boolean(
                          getIn(touched, 'equipment.trailerLicenseHook') &&
                          getIn(errors, 'equipment.trailerLicenseHook')
                        )}
                        helperText={Boolean(
                          getIn(touched, 'equipment.trailerLicenseHook') &&
                          getIn(errors, 'equipment.trailerLicenseHook')
                        )}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                      />
                    </Grid>
                    }
                  </Grid>
                </FormElements.FormSubsection>

                {/* Load Origin */}
                <FormElements.FormSubsection>
                  <Grid container spacing={1}>
                    <Grid size={{ xs: 12 }}>
                      <CTTabs
                        labels={originTab}
                        tabIndex={currentOriginTabIndex}
                        addNewButtonEnabled={true}
                        removeButtonEnabled={true}
                        fnOnAddTabHandler={() => addNewTab('ORIGIN', values)}
                        fnOnRemoveTabHandler={(tab) => handleRemoveTab('ORIGIN', tab, values)}
                        fnOnTabChangeHandler={tabIndex => changeTab('ORIGIN', tabIndex)}
                      />
                      {ConfirmationDialog}
                    </Grid>
                    <Grid size={{ xs: 12, sm: 8 }}>
                      <Box display='flex'>
                        <div style={{ flex: 1 }}>
                          <CustomSelectField
                            type='LOCATION'
                            id='origins'
                            label='Origin Name'
                            name={`origin[${currentOriginTabIndex}].name`}
                            data={locations.map(c => getDisplayLabel(c, 'LOCATION'))}
                            value={values.origin[currentOriginTabIndex].name}
                            placement='top'
                            onChange={selected => {
                              setFieldValue(`origin[${currentOriginTabIndex}].name`, selected);
                              handleLocationChange(setFieldValue, 'ORIGIN', selected, currentOriginTabIndex);
                            }}
                          />
                          <ErrorMessage name={`origin[${currentOriginTabIndex}].name`} component={'grid'} style={{ color: colors.error.main }} />
                        </div>
                        <IconButton color='primary' onClick={() => setLocationFormDialog(true)} size='small'><AddCircleOutlineOutlined /></IconButton>
                      </Box>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <DatePicker
                        format='MM/dd/yyyy hh:mm aa'
                        showMeridiem
                        showWeekNumbers
                        name={`origin[${currentOriginTabIndex}].appointment`}
                        value={values.origin[currentOriginTabIndex].appointment}
                        error={Boolean(
                          getIn(touched, 'origin.appointment') &&
                          getIn(errors, 'origin.appointment')
                        )}
                        helperText={Boolean(
                          getIn(touched, 'origin.appointment') &&
                          getIn(errors, 'origin.appointment')
                        )}
                        onChange={(date) => setFieldValue(`origin[${currentOriginTabIndex}].appointment`, date)}
                        required={true}
                        placement={'topStart'}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <InputField
                        label='Contact Person Name'
                        type='text'
                        name={`origin[${currentOriginTabIndex}].contactPerson`}
                        value={values.origin[currentOriginTabIndex].contactPerson}
                        variant='outlined'
                        fullWidth
                        error={Boolean(touched.contactPerson && errors.contactPerson)}
                        helperText={touched.contactPerson && errors.contactPerson}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <InputField
                        label='Contact Person Email'
                        type='text'
                        name={`origin[${currentOriginTabIndex}].contactEmail`}
                        value={values.origin[currentOriginTabIndex].contactEmail}
                        variant='outlined'
                        fullWidth
                        error={Boolean(touched.contactEmail && errors.contactEmail)}
                        helperText={touched.contactEmail && errors.contactEmail}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <InputField
                        label='PU Number'
                        type='text'
                        name={`origin[${currentOriginTabIndex}].puNumber`}
                        value={values.origin[currentOriginTabIndex].puNumber}
                        variant='outlined'
                        fullWidth
                        error={Boolean(touched.puNumber && errors.puNumber)}
                        helperText={touched.puNumber && errors.puNumber}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                      <InputField
                        label='Instructions'
                        type='text'
                        name={`origin[${currentOriginTabIndex}].notes`}
                        value={values.origin[currentOriginTabIndex].notes}
                        variant='outlined'
                        fullWidth
                        error={Boolean(touched.notes && errors.notes)}
                        helperText={touched.notes && errors.notes}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                      />
                    </Grid>
                  </Grid>
                </FormElements.FormSubsection>

                {/* Load Destination */}
                <FormElements.FormSubsection>
                  <Grid container spacing={1}>
                    <Grid size={{ xs: 12 }}>
                      <CTTabs
                        labels={destinationTab}
                        tabIndex={currentDestinationTabIndex}
                        addNewButtonEnabled={true}
                        removeButtonEnabled={true}
                        fnOnAddTabHandler={() => addNewTab('DESTINATION', values)}
                        fnOnRemoveTabHandler={(tab) => handleRemoveTab('DESTINATION', tab, values)}
                        fnOnTabChangeHandler={tabIndex => changeTab('DESTINATION', tabIndex)}
                      />
                      {ConfirmationDialog}
                    </Grid>
                    <Grid size={{ xs: 12, sm: 8 }}>
                      <Box display='flex'>
                        <div style={{ flex: 1 }}>
                          <CustomSelectField
                            type='LOCATION'
                            id='destinations'
                            label='Destination Name'
                            name={`destination[${currentDestinationTabIndex}].name`}
                            data={locations.map(c => getDisplayLabel(c, 'LOCATION'))}
                            value={values.destination[currentDestinationTabIndex].name}
                            placement='top'
                            onChange={selected => {
                              setFieldValue(`destination[${currentDestinationTabIndex}].name`, selected);
                              handleLocationChange(setFieldValue, 'DESTINATION', selected, currentDestinationTabIndex);
                            }}
                          />
                          <ErrorMessage name={`destination[${currentDestinationTabIndex}].name`} component={'grid'} style={{ color: colors.error.main }} />
                        </div>
                        <IconButton color='primary' onClick={() => setLocationFormDialog(true)} size='small'><AddCircleOutlineOutlined /></IconButton>
                      </Box>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <DatePicker
                        format='MM/dd/yyyy hh:mm aa'
                        showMeridiem
                        showWeekNumbers
                        name={`destination[${currentDestinationTabIndex}].appointment`}
                        value={values.destination[currentDestinationTabIndex].appointment}
                        error={Boolean(
                          getIn(touched, 'destination.appointment') &&
                          getIn(errors, 'destination.appointment')
                        )}
                        helperText={Boolean(
                          getIn(touched, 'destination.appointment') &&
                          getIn(errors, 'destination.appointment')
                        )}
                        onChange={(date) => setFieldValue(`destination[${currentDestinationTabIndex}].appointment`, date)}
                        required={true}
                        placement={'topStart'}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <InputField
                        label='Contact Person Name'
                        type='text'
                        name={`destination[${currentDestinationTabIndex}].contactPerson`}
                        value={values.destination[currentDestinationTabIndex].contactPerson}
                        variant='outlined'
                        fullWidth
                        error={Boolean(touched.contactPerson && errors.contactPerson)}
                        helperText={touched.contactPerson && errors.contactPerson}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <InputField
                        label='Contact Person Email'
                        type='text'
                        name={`destination[${currentDestinationTabIndex}].contactEmail`}
                        value={values.destination[currentDestinationTabIndex].contactEmail}
                        variant='outlined'
                        fullWidth
                        error={Boolean(touched.contactEmail && errors.contactEmail)}
                        helperText={touched.contactEmail && errors.contactEmail}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <InputField
                        label='Delivery Number'
                        type='text'
                        name={`destination[${currentDestinationTabIndex}].deliveryNumber`}
                        value={values.destination[currentDestinationTabIndex].deliveryNumber}
                        variant='outlined'
                        fullWidth
                        error={Boolean(touched.deliveryNumber && errors.deliveryNumber)}
                        helperText={touched.deliveryNumber && errors.deliveryNumber}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                      <InputField
                        label='Instructions'
                        type='text'
                        name={`destination[${currentDestinationTabIndex}].notes`}
                        value={values.destination[currentDestinationTabIndex].notes}
                        variant='outlined'
                        fullWidth
                        error={Boolean(touched.notes && errors.notes)}
                        helperText={touched.notes && errors.notes}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        size='small'
                      />
                    </Grid>
                  </Grid>
                </FormElements.FormSubsection>
              </FormElements.FormSection>
              <Stack spacing={1} sx={{ width: { xs: '100%', md: '280px' }, flexShrink: 0 }}>
                <FormElements.SideBar height={'210px'}>
                  <Typography variant='body1' color={colors.neutral[700]}>Order Notes</Typography>
                  <InputField
                    type='text'
                    placeholder='Add additional'
                    name='summary.notes'
                    value={values.summary.notes}
                    variant='outlined'
                    fullWidth
                    error={Boolean(touched.notes && errors.notes)}
                    helperText={touched.notes && errors.notes}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    size='small'
                    sx={{
                      '&.MuiTextField-root': {
                        height: '150px',
                      },
                      '.MuiInputBase-root': {
                        height: 'inherit',
                      }
                    }}
                  />
                </FormElements.SideBar>
                <FormElements.SideBar height={'280px'} sx={{ flexShrink: 0 }}>
                  {isProcessingDistanceCalculation && <Box textAlign={'center'}> <CircularProgress /> </Box>}
                  <Typography variant='subtitle1' fontWeight={600} color={colors.neutral[900]}>{'Order Summary'}</Typography>
                  <Stack spacing={1} alignItems={'stretch'}>
                    <Box display={'flex'} justifyContent={'space-between'}>
                      <Typography variant='body1' color={colors.neutral[500]}>Order Rate</Typography>
                      <Typography variant='body1' fontWeight={500} color={colors.neutral[500]}>{formatCurrency(values.summary.lineHaulCharges)}</Typography>
                    </Box>
                    <Box display={'flex'} justifyContent={'space-between'}>
                      <Typography variant='body1' color={colors.neutral[500]}>FSC</Typography>
                      <Typography variant='body1' fontWeight={500} color={colors.neutral[500]}>{values.summary.fuelChargesType === '$' ? formatCurrency(values.summary.fuelCharges) : `${values.summary.fuelCharges}%`}</Typography>
                    </Box>
                    <Box display={'flex'} justifyContent={'space-between'}>
                      <Typography variant='body1' color={colors.neutral[500]}>Expenses</Typography>
                      <Typography variant='body1' fontWeight={500} color={colors.neutral[500]}>{formatCurrency(AggregateOrderExpenses(expenseList))}</Typography>
                    </Box>
                    <Box display={'flex'} justifyContent={'space-between'}>
                      <Typography variant='subtitle2' color={colors.neutral[800]}>Total</Typography>
                      <Typography variant='subtitle2' fontWeight={500} color={colors.neutral[800]}>{formatCurrency(calculateOrderTotal(values.summary.lineHaulCharges, values.summary.fuelCharges, values.summary.fuelChargesType, expenseList))}</Typography>
                    </Box>
                    <Box></Box>
                    <Box display={'flex'} justifyContent={'space-between'}>
                      <Typography variant='body1' color={colors.neutral[500]}>Total Miles</Typography>
                      <Typography variant='body1' fontWeight={500} color={colors.neutral[500]}>{values.summary.distance || '-'}</Typography>
                    </Box>
                    <Box display={'flex'} justifyContent={'space-between'}>
                      <Typography variant='body1' color={colors.neutral[500]}>Duration</Typography>
                      <Typography variant='body1' fontWeight={500} color={colors.neutral[500]}>{values.summary.duration || '-'}</Typography>
                    </Box>
                  </Stack>
                </FormElements.SideBar>
                {/* This is upload document. we will enable it after the demo */}
                {/* <FormElements.SideBar height={'295px'}>
                  <Stack>
                    <Box>
                      <Avatar sx={{ background: 'none' }}>{<FTIcons.Folder />}</Avatar>
                      <Button
                        size='large'
                        color='primary'
                        variant='outlined'
                        startIcon={<FTIcons.UploadSimple width={24} height={24} />}
                      >Upload Document</Button>
                      <Typography sx={{ fontSize: 9, fontWeight: 400 }} color={colors.neutral[400]}>
                        Supported format: PDF, Docs. Max file size: 5MB.
                      </Typography>
                    </Box>
                    <Box>
                      <List>
                        <ListItemIcon>{FTIcons.Folder}</ListItemIcon>
                        <Box>
                          <ListItemText primaryText='Proof of Delivery'></ListItemText>
                          <ListItemIcon secondaryText='Final proof of delivery'></ListItemIcon>
                        </Box>
                        <IconButton>
                          <DeleteOutlineOutlined />
                        </IconButton>
                      </List>
                    </Box>

                  </Stack>
                </FormElements.SideBar> */}
              </Stack>
            </Stack>
            <Box display='flex' justifyContent='flex-end' p={2}>
              <Button onClick={() => cancelDialogHandler()}>Cancel</Button>
              <Button
                type='submit'
                variant='contained'
                color='primary'
              >
                {formAction}
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
      {isBrokerFormDialogOpen && <DataDialog
        toast={toast}
        isProcessing={isProcessing}
        open={isBrokerFormDialogOpen}
        title={'Add Broker'}
        onCloseHandler={() => closeFormDialog('broker')}
      >
        <BrokerForm
          action='Save'
          broker={{
            name: '',
            email: '',
            phone: '',
            street: '',
            city: '',
            state: '',
            zipcode: '',
            country: '',
            isActive: true,
          }}
          isFormModal={true}
          saveFormHandler={model => saveBroker(model)}
        />
      </DataDialog>}
      {isTruckFormDialogOpen && <DataDialog
        toast={toast}
        isProcessing={isProcessing}
        open={isTruckFormDialogOpen}
        title={'Add Truck'}
        onCloseHandler={() => closeFormDialog('truck')}
      >
        <TruckForm
          action='Save'
          truck={{
            truckType: '',
            mcNumber: '',
            dotNumber: '',
            truckNumber: '',
            make: '',
            model: '',
            registeredCountry: '',
            registeredState: '',
            licensePlate: '',
            registrationExpirationDate: '',
            year: '',
            vinNumber: '',
            insuranceNumber: '',
            insuranceExpirationDate: '',
            isAvailable: true,
            capacityWeight: '',
            length: '',
            totalMilesDriven: '',
            lastServiceDate: '',
          }}
          isFormModal={true}
          saveFormHandler={model => saveTruck(model)}
        />
      </DataDialog>}
      {isLocationFormDialogOpen && <DataDialog
        toast={toast}
        isProcessing={isProcessing}
        open={isLocationFormDialogOpen}
        title={'Add Location'}
        onCloseHandler={() => closeFormDialog('location')}
      >
        <LocationForm
          action='Save'
          location={{
            name: '',
            email: '',
            phone: '',
            street: '',
            city: '',
            state: '',
            zipcode: '',
            country: '',
            isActive: true,
          }}
          isFormModal={true}
          saveFormHandler={model => saveLocation(model)}
        />
      </DataDialog>}
      {isExpenseDialogOpen && <DataDialog
        open={isExpenseDialogOpen}
        title={'Expense'}
        width={'md'}
        onCloseHandler={() => setExpenseDialog(false)}
      >
        <OrderExpense
          action={expenseAction}
          expense={expense}
          expenseList={expenseList}
          fnOnSaveHandler={(expense) => saveExpense(expense)}
          fnOnUpdateHandler={(expense) => updateExpense(expense)}
          fnOnEditHandler={(expense) => editRow(expense)}
          fnOnDeleteHandler={(expense) => deleteExpense(expense)}
        />
      </DataDialog>}
      {isPreNoteDocumentDialogOpen && <DataDialog
        open={isPreNoteDocumentDialogOpen}
        title={'Pre-Load Document'}
        width={'md'}
        onCloseHandler={() => { setPreNoteDocumentDialog(false); setPreNoteToast(null); }}
      >
        <FileUploader
          name={'LoadForm'}
          isProcessing={isProcessingPreNoteDocument}
          message={preNoteToast}
          fnOnUploadHandler={(file) => handleCreateLoadWithAI(file)}
        />
      </DataDialog>}
    </Box>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveBroker: (data) => dispatch(BrokerAction.save(data)),
    saveLocation: (data) => dispatch(LocationAction.save(data)),
    saveTruck: (data) => dispatch(TruckAction.saveTruck(data)),
    resetToastState: (entity) => {
      if (entity === 'broker') {
        dispatch(BrokerAction.resetState('RESET_TOAST_STATE'));
      } else if (entity === 'Location') {
        dispatch(LocationAction.resetState('RESET_TOAST_STATE'));
      } else {
        dispatch(TruckAction.resetTruckState('RESET_TOAST_STATE'));
      }
    }
  }
};

function mapStatesToProps(state) {
  // Whatevet is returned will show up as props
  const { brokers } = state.brokerReducer;
  const { locations } = state.locationReducer;
  const { trucks } = state.truckReducer;
  let toast = {}, isProcessing = false;
  if (state.brokerReducer.toast && state.brokerReducer.toast.type && state.brokerReducer.toast.message) {
    toast = state.brokerReducer.toast;
    isProcessing = state.brokerReducer.isProcessing;
  } else if (state.locationReducer.toast && state.locationReducer.toast.type && state.locationReducer.toast.message) {
    toast = state.locationReducer.toast;
    isProcessing = state.locationReducer.isProcessing;
  } else {
    toast = state.truckReducer.toast;
    isProcessing = state.truckReducer.isProcessing;
  }

  return {
    brokers, locations, trucks, toast, isProcessing
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(OTRLoadForm);